import PropTypes from 'prop-types';
import React, { createContext, useEffect, useCallback, useMemo } from 'react';
// utils
//
import axiosInstance from 'src/utils/axios';
// ----------------------------------------------------------------------

// NOTE:
// We only build demo at basic level.
// Customer will need to do some extra handling yourself if you want to extend the logic and other features...

// ----------------------------------------------------------------------


// ----------------------------------------------------------------------

export const PermissionContext = createContext({
  checkPermission: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

PermissionProvider.propTypes = {
  children: PropTypes.node,
};

export function PermissionProvider({ children }) {
  const [permissions, setPermissions] = React.useState([]);

  const initialize = useCallback(async () => {
    try {
      const response = await axiosInstance.get('/admin/auth/permissions');
      setPermissions(response.data)

    } catch (error) {
      console.error(error);

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkPermission = (code) => {
    if (permissions.includes(code)) {
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PermissionContext.Provider value={{
    checkPermission
  }}>{children}</PermissionContext.Provider>;
}
